import { ServerUrls } from "./ServerUrls";

export class ServerCalls {
    static version = ServerUrls.baseRestApiURL + "Version";
    static login = ServerUrls.baseRestApiURL + "Login";

    static getOrganizations = ServerUrls.baseRestApiURL + "GetOrganizations";
    static getOrganizationsForSelect = ServerUrls.baseRestApiURL + "GetOrganizationsForSelect";
    static getOrganizationManagersForSelect = ServerUrls.baseRestApiURL + "GetOrganizationManagersForSelect";

    static getDemoUsers = ServerUrls.baseRestApiURL + "GetDemoUsers";

    static getCategories = ServerUrls.baseRestApiURL + "GetCategories";
    static getSubCategories = ServerUrls.baseRestApiURL + "GetSubCategories";
    static deleteOrganization = ServerUrls.baseRestApiURL + "DeleteOrganizations";
    static getSurveys = ServerUrls.baseRestApiURL + "GetSurveys";
    static getOrganizationById = ServerUrls.baseRestApiURL + "GetOrganizationById";
    static getDepartments = ServerUrls.baseRestApiURL + "GetDepartments";
    static getEmployees = ServerUrls.baseRestApiURL + "GetEmployees";
    static getCategoryById = ServerUrls.baseRestApiURL + "GetCategoryById";
    static getSubCategoryById = ServerUrls.baseRestApiURL + "GetSubCategoryById";
    static saveCategory = ServerUrls.baseRestApiURL + "SaveCategory";
    static saveSubCategory = ServerUrls.baseRestApiURL + "SaveSubCategory";
    static deleteCategoryById = ServerUrls.baseRestApiURL + "DeleteCategoryById";
    static deleteSubCategoryById = ServerUrls.baseRestApiURL + "DeleteSubCategoryById";
    static saveOrganization = ServerUrls.baseRestApiURL + "SaveOrganization";
    static generateSurveyPreview = ServerUrls.baseRestApiURL + "GenerateSurveyPreview";

    static copyQuestions = ServerUrls.baseRestApiURL + "CopyQuestions";
    static saveQuestionOrder = ServerUrls.baseRestApiURL + "SaveQuestionOrder";
    
    static getDepartmentById = ServerUrls.baseRestApiURL + "GetDepartmentById";
    static saveDepartment = ServerUrls.baseRestApiURL + "SaveDepartment";
    static deleteDepartmentById = ServerUrls.baseRestApiURL + "DeleteDepartmentById";

    static getEmployeeById = ServerUrls.baseRestApiURL + "GetEmployeeById";
    static saveEmployee = ServerUrls.baseRestApiURL + "SaveEmployee";
    static deleteEmployeeById = ServerUrls.baseRestApiURL + "DeleteEmployeeById";
    static getManagers = ServerUrls.baseRestApiURL + "GetManagers";
    static getManagersWithEmployees = ServerUrls.baseRestApiURL + "GetManagersWithEmployees";

    static getSurveyById = ServerUrls.baseRestApiURL + "GetSurveyById";
    static addEmployeeToSurvey = ServerUrls.baseRestApiURL + "AddEmployeeToSurvey";
    static saveSurvey = ServerUrls.baseRestApiURL + "SaveSurvey";
    static deleteSurveyById = ServerUrls.baseRestApiURL + "DeleteSurveyById";

    static duplicateSurveybyId = ServerUrls.baseRestApiURL + "DuplicateSurveybyId";
    
    static getSurveyQuestions = ServerUrls.baseRestApiURL + "GetSurveyQuestions";
    static getSurveyQuestionById = ServerUrls.baseRestApiURL + "GetSurveyQuestionById";
    static saveQuestion = ServerUrls.baseRestApiURL + "SaveQuestion";
    static deleteQuestionById = ServerUrls.baseRestApiURL + "DeleteQuestionById";

    //static getSurveysByOrganizationId = ServerUrls.baseRestApiURL + "GetSurveysByOrganizationId";
    static getManagersEmployees = ServerUrls.baseRestApiURL + "GetManagersEmployees";

    static distributeSurvey = ServerUrls.baseRestApiURL + "DistributeSurvey";
    static reallyDistributeSurvey = ServerUrls.baseRestApiURL + "ReallyDistributeSurvey";
    static getDistributedSurveysBySurveyId = ServerUrls.baseRestApiURL + "GetDistributedSurveysBySurveyId";
    static getDistributedSurveys = ServerUrls.baseRestApiURL + "GetDistributedSurveys";
    static getDistributedSurveysForCorporateReport = ServerUrls.baseRestApiURL + "GetDistributedSurveysForCorporateReport";
    

    static getOrganizationsForReportSelect = ServerUrls.baseRestApiURL + "GetOrganizationsForReportSelect";
    static getOrganizationsForCorporateReportSelect = ServerUrls.baseRestApiURL + "GetOrganizationsForCorporateReportSelect";

    static downloadDemoUsers = ServerUrls.baseRestApiURL + "GenerateDemoUserReportInExcel";
    
    static getSurveysForSelect = ServerUrls.baseRestApiURL + "GetSurveysForSelect";
    

    static getDistributedSurveyBatchNumber = ServerUrls.baseRestApiURL + "GetDistributedSurveyBatchNumber";
    static getPendingSurveyEmployeeByBatchNumber = ServerUrls.baseRestApiURL + "GetPendingSurveyEmployeeByBatchNumber";

    static getDashboardData = ServerUrls.baseRestApiURL + "GetDashboardData";
    static toggleIgnoreDistributedSurveyById = ServerUrls.baseRestApiURL + "ToggleIgnoreDistributedSurveyById";
    static deleteDistributedSurveyById = ServerUrls.baseRestApiURL + "DeleteDistributedSurveyById";
    static deleteDistributedSurveyByBatchNumber = ServerUrls.baseRestApiURL + "DeleteDistributedSurveyByBatchNumber";
    
    
    static stopDistributedSurveysByBatchNumber = ServerUrls.baseRestApiURL + "StopDistributedSurveysByBatchNumber";
    static resumeDistributedSurveysByBatchNumber = ServerUrls.baseRestApiURL + "ResumeDistributedSurveysByBatchNumber";

    static uploadExcel = ServerUrls.baseRestApiURL + "UploadExcel";
    static processExcel = ServerUrls.baseRestApiURL + "ProcessExcel";

    static resendSurveyLink = ServerUrls.baseRestApiURL + "ResendSurveyLink";
    static resendLink = ServerUrls.baseRestApiURL + "ResendLink";

    static sendSurveyReminders = ServerUrls.baseRestApiURL + "SendSurveyReminders";
    static sendReminder = ServerUrls.baseRestApiURL + "SendReminder";

    static generateReportForDistributedSurveyBatchNumber = ServerUrls.baseRestApiURL + "GenerateReportForDistributedSurveyBatchNumber";
    static generateReportForOrgInExcel = ServerUrls.baseRestApiURL + "GenerateReportForOrgInExcel";

    static generateM3PlusCorporateReportForBatchNumbers = ServerUrls.baseRestApiURL + "generateM3PlusCorporateReportForBatchNumbers";
    static generateM3CorporateReportForBatchNumbers = ServerUrls.baseRestApiURL + "generateM3CorporateReportForBatchNumbers";
    static generateM3NewQuestionCorporateReportForBatchNumbers = ServerUrls.baseRestApiURL + "GenerateM3NewQuestionCorporateReportForBatchNumbers";    
    static generateM3DepartmentReportForBatchNumbers = ServerUrls.baseRestApiURL + "GenerateM3AttributeReportForBatchNumbers";
    static generateM3NewQuestionDepartmentReportForBatchNumbers = ServerUrls.baseRestApiURL + "GenerateM3NewQuestionAttributeReportForBatchNumbers";
    
    static generateM3PlusDepartmentReportForBatchNumbers = ServerUrls.baseRestApiURL + "GenerateM3PlusAttributeReportForBatchNumbers";
    
    
    static generateM3CorporateReportAttributeForBatchNumbers = ServerUrls.baseRestApiURL + "generateM3CorporateReportAttributeForBatchNumbers";
    static generateM3CorporateDepartmentManagerReportForBatchNumbers = ServerUrls.baseRestApiURL + "GenerateM3CorporateDepartmentManagerReportForBatchNumbers";
    static generateM3NewQuestionCorporateReportAttributeForBatchNumbers = ServerUrls.baseRestApiURL + "GenerateM3NewQuestionCorporateReportAttributeForBatchNumbers";
    
    static generateM3PlusCorporateReportAttributeForBatchNumbers = ServerUrls.baseRestApiURL + "generateM3PlusCorporateReportAttributeForBatchNumbers";
    
    static bulkActionQueueModify = ServerUrls.baseRestApiURL + "BulkActionQueueModify";

    static viewReportForDistributedSurveyBatchNumber = ServerUrls.baseRestApiURL + "ViewReportForDistributedSurveyBatchNumber";

    static queueReportEmailForBatchNumber = ServerUrls.baseRestApiURL + "QueueReportEmailForBatchNumber";
    static resendReportEmailForBatchNumber = ServerUrls.baseRestApiURL + "ResendReportEmailForBatchNumber";
    static updateTips = ServerUrls.baseRestApiURL + "updateTips";

    static getQueuedEmails = ServerUrls.baseRestApiURL + "GetQueuedEmails";
    static getQueuedEmailsForListing = ServerUrls.baseRestApiURL + "GetQueuedEmailsForListing";
    static getQueuedSurveysForListing = ServerUrls.baseRestApiURL + "GetQueuedSurveysForListing";
    
    

    static manuallySendQueuedEmail = ServerUrls.baseRestApiURL + "ManuallySendQueuedEmail";
    static dontSendQueuedEmail = ServerUrls.baseRestApiURL + "DontSendQueuedEmail";
    static addSendQueuedEmail = ServerUrls.baseRestApiURL + "AddSendQueuedEmail";
    static queueTipEmailAgain = ServerUrls.baseRestApiURL + "QueueTipEmailAgain";

    static manuallySendQueuedSurvey = ServerUrls.baseRestApiURL + "ManuallySendQueuedSurvey";
    static dontSendQueuedSurvey = ServerUrls.baseRestApiURL + "DontSendQueuedSurvey";
    static addSendQueuedSurvey = ServerUrls.baseRestApiURL + "AddSendQueuedSurvey";
    static queueSurveyAgain = ServerUrls.baseRestApiURL + "QueueSurveyAgain";


};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/classes/ServerCalls.ts